import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {SelectField} from "./FilterComponentStyles";

const WorkingModelFilter = ({
    value,
    onChange,
    disabled = true,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    showLabel = true,
    marginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const [workingModelsLoading, workingModels] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.listWorkingModels.bind(null, {
            isActive: true
        }),
        initialCall: initialCall
    });

    return (
        <React.Fragment>
            {showLabel && <h5>Çalışma Modeli</h5>}
            <SelectField
                showSearch
                loading={workingModelsLoading}
                data-testid="workingModelSelect"
                value={value}
                onChange={onChange}
                disabled={disabled || workingModelsLoading}
                mode={mode}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                {workingModels?.result &&
                    workingModels?.result?.length > 0 &&
                    workingModels?.result?.map(workingModel => (
                        <SelectField.Option
                            key={workingModel?._id}
                            value={workingModel?._id}
                            data-testid="workingModelSelect_option"
                        >
                            {workingModel?.label?.tr}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};

export default WorkingModelFilter;
